var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewgameInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.60161 3.05035C5.1572 2.38744 5.97417 2 6.84064 2H17.1594C18.0258 2 18.8428 2.38744 19.3984 3.05035L23.2995 7.70497C24.2479 8.83657 24.2317 10.5046 23.2605 11.617L14.2001 21.9952C13.0304 23.3349 10.9696 23.3349 9.79991 21.9952L0.739465 11.617C-0.231719 10.5046 -0.247883 8.83657 0.700526 7.70497L4.60161 3.05035ZM6.84064 4C6.57471 4 6.31582 4.11863 6.13445 4.33503L2.23336 8.98965C1.9172 9.36688 1.92312 9.93178 2.24609 10.3017L11.3065 20.6798C11.6792 21.1067 12.3208 21.1067 12.6935 20.6798L21.7539 10.3017C22.0769 9.93177 22.0828 9.36688 21.7666 8.98965L17.8656 4.33503C17.6842 4.11863 17.4253 4 17.1594 4H6.84064Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.5C11.7158 6.5 11.4433 6.61288 11.2424 6.81381C11.0415 7.01475 10.9286 7.28727 10.9286 7.57143V9.92857H8.57143C8.28727 9.92857 8.01475 10.0415 7.81381 10.2424C7.61288 10.4433 7.5 10.7158 7.5 11C7.5 11.2842 7.61288 11.5567 7.81381 11.7576C8.01475 11.9585 8.28727 12.0714 8.57143 12.0714H10.9286V14.4286C10.9286 14.7127 11.0415 14.9853 11.2424 15.1862C11.4433 15.3871 11.7158 15.5 12 15.5C12.2842 15.5 12.5567 15.3871 12.7576 15.1862C12.9585 14.9853 13.0714 14.7127 13.0714 14.4286V12.0714H15.4286C15.7127 12.0714 15.9853 11.9585 16.1862 11.7576C16.3871 11.5567 16.5 11.2842 16.5 11C16.5 10.7158 16.3871 10.4433 16.1862 10.2424C15.9853 10.0415 15.7127 9.92857 15.4286 9.92857H13.0714V7.57143C13.0714 7.28727 12.9585 7.01475 12.7576 6.81381C12.5567 6.61288 12.2842 6.5 12 6.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewgameInactive);
export default __webpack_public_path__ + "static/media/newgame_inactive.4bf39b845908ea3ce25a07f0f7f0322f.svg";
export { ForwardRef as ReactComponent };